<template>
    <div>
        <!--面包屑-->
        <breadcrumb-link></breadcrumb-link>
        <!--内容区域-->
        <div>
            <!--查询条件-->
            <el-col :span="24" class="toolbar">
                <el-form :inline="true" :model="filters" ref="filters">
                    <el-form-item label="kafka集群名称:" prop="name">
                        <el-input v-model="filters.name" placeholder="kafka集群名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="创建时间:">
                        <el-date-picker clearable @change="changeTime" v-model="timeRange" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" :default-time="['00:00:00', '23:59:59']" start-placeholder="开始时间" end-placeholder="结束时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getListCX">
                            查询
                        </el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="resetForm('filters')">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <!--新增按钮-->
            <div class="text-right pb10">
                <el-button type="primary" @click="goForm('add')">新增</el-button>
            </div>
            <!--列表-->
            <el-table :data="listsFilter" border highlight-current-row v-loading="listLoading" style="width: 100%;" :header-cell-style="{ background: '#f2f2f2' }">
                <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                <el-table-column prop="name" label="kafka集群名称" align="center" min-width="300"></el-table-column>
                <el-table-column prop="clusterAddress" label="地址及端口" align="center" min-width="180">
                </el-table-column>
                <el-table-column prop="topicNum" label="topic数量" align="center" min-width="100">
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center" min-width="180">
                    <template slot-scope="scope">
                        {{ dateFormat(scope.row.updateTime) }}
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="" label="备注" align="center" min-width="180">
                </el-table-column> -->
                <el-table-column prop="creatorName" label="创建人" align="center" min-width="100">
                </el-table-column>
                <el-table-column fixed="right" label="操作" align="center" min-width="150">
                    <template slot-scope="scope">
                        <el-button @click="goForm('details', scope.row.id)" size="mini" type="text">详情
                        </el-button>
                        <el-button @click="goForm('edit', scope.row.id)" size="mini" type="text">修改
                        </el-button>
                        <el-button @click="deleteData(scope.row.id)" size="mini" type="text">删除
                        </el-button>
                    </template>
                </el-table-column>
                <div slot="empty">{{ count == 0 ? "暂无数据" : message }}</div>
            </el-table>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="current" :page-sizes="[10, 20, 30, 40, 50]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="count"></el-pagination>
            </el-col>
        </div>
    </div>
</template>

<script>
import BreadcrumbLink from "../../components/breadcrumbLink";
import util from "@/utils/util";
import { getDbType } from "@/apis/pipelineService/physicalDb";
import {
    deleteKafkaCluster,
    getKafkaList
} from "@/apis/pipelineService/kafkaService";

export default {
    components: {
        BreadcrumbLink
    },
    data() {
        return {
            timeRange: [],
            moduleName: "",
            count: 0, // 多少条数据
            listLoading: false, // 加载
            size: 10, // 每页的数据
            current: 1, // 初始页
            lists: [],
            code: "", // 列表无数据默认值
            message: "", // 列表无数据默认值
            filters: {
                name: null,
                startTime: null,
                endTime: null
            },
            dbTypeList: [], // 类型列表
            searchOptions: {
                name: null,
                startTime: null,
                endTime: null
            },
            row: {},
        };
    },
    mounted() {
        this.getList();
    },
    computed: {
        listsFilter() {
            return this.lists;
        }
    },
    methods: {
        // 页码
        handleSizeChange(size) {
            this.size = size;
            this.getList();
        },
        handleCurrentChange(current) {
            this.current = current;
            this.getList();
        },
        // 查询
        getListCX() {
            this.current = 1;
            this.searchOptions = { ...this.filters };
            this.getList();
        },
        // 重置筛选条件
        resetForm(formName) {
            this.timeRange = [];
            this.$refs[formName].resetFields();
            this.filters = {
                name: null,
                startTime: null,
                endTime: null
            };
            this.searchOptions = {
                name: null,
                startTime: null,
                endTime: null
            };
            this.current = 1;
            this.getList();
        },
        // 跳转详情或者新增
        goForm(type, id) {
            this.$router.push({
                path: "/kafkaConfigForm",
                query: {
                    id,
                    type
                }
            });
        },
        // 列表时间格式化
        dateFormat(timestamp) {
            if (timestamp) {
                return util.timestampToTime13(timestamp);
            }
            return "--";
        },
        // 获取列表数据
        async getList() {
            const params = {
                ...this.searchOptions,
                current: this.current, // 当前页
                size: this.size // 当前条数
            };
            try {
                const data = await getKafkaList(params);
                if (data.code == 0 && data.data) {
                    this.count = data.data.total; // 列表总条数
                    this.lists = data.data.records; // 列表数据
                }
                this.message = data.msg;
            } catch (error) {}
        },
        // 删除列表
        deleteData(data) {
            this.$confirm("是否确认删除该kafka集群?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.deleteKafkaClusterFun(data);
                })
                .catch(() => {
                });
        },
        // 删除接口
        async deleteKafkaClusterFun(data) {
            const params = {
                id: data
            };
            try {
                const data = await deleteKafkaCluster(params);
                if (data.code == 0) {
                    this.$message.success(data.message || "删除成功");
                    this.getList();
                }else {
                    this.$message.error(data.message || "删除失败");
                }
            } catch (error) {}
        },
        // 选择时间
        changeTime(data) {
            if (data.length > 0) {
                this.filters.startTime = data[0];
                this.filters.endTime = data[1];
            } else {
                this.filters.startTime = null;
                this.filters.endTime = null;
            }
        }
    }
};
</script>

<style scoped></style>
